"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeroXQuote = exports.ZERO_X_PRICE_DECIMALS = void 0;
const shared_models_1 = require("@railgun-community/shared-models");
const axios_1 = require("axios");
const contract_addresses_1 = require("@0x/contract-addresses");
const zero_x_fetch_1 = require("./zero-x-fetch");
const number_1 = require("../../utils/number");
const ethers_1 = require("ethers");
exports.ZERO_X_PRICE_DECIMALS = 18;
const NULL_SPENDER_ADDRESS = '0x0000000000000000000000000000000000000000';
const ZERO_X_PROXY_BASE_TOKEN_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
class ZeroXQuote {
}
exports.ZeroXQuote = ZeroXQuote;
_a = ZeroXQuote;
ZeroXQuote.getZeroXTokenAddress = (erc20) => {
    if (erc20.isBaseToken ?? false) {
        return ZERO_X_PROXY_BASE_TOKEN_ADDRESS;
    }
    return erc20.tokenAddress;
};
ZeroXQuote.zeroXExchangeProxyContractAddress = (networkName) => {
    const { chain } = shared_models_1.NETWORK_CONFIG[networkName];
    const addresses = (0, contract_addresses_1.getContractAddressesForChainOrThrow)(chain.id);
    return addresses.exchangeProxy;
};
ZeroXQuote.supportsNetwork = (networkName) => {
    try {
        (0, zero_x_fetch_1.zeroXApiSubdomain)(networkName);
        return true;
    }
    catch {
        return false;
    }
};
ZeroXQuote.getZeroXQuoteInvalidError = (networkName, to, sellTokenAddress, buyTokenAddress) => {
    try {
        const exchangeProxyContractAddress = _a.zeroXExchangeProxyContractAddress(networkName);
        if (![
            exchangeProxyContractAddress.toLowerCase(),
            sellTokenAddress.toLowerCase(),
            buyTokenAddress.toLowerCase(),
        ].includes(to.toLowerCase())) {
            throw new Error(`Invalid 0x Exchange contract address: ${to} vs ${exchangeProxyContractAddress}`);
        }
        return undefined;
    }
    catch (err) {
        return err;
    }
};
ZeroXQuote.getSwapQuote = async ({ networkName, sellERC20Amount, buyERC20Info, slippageBasisPoints, isRailgun, }) => {
    if (sellERC20Amount.amount === 0n) {
        throw new Error('Swap sell amount is 0.');
    }
    const sellTokenAddress = _a.getZeroXTokenAddress(sellERC20Amount);
    const buyTokenAddress = _a.getZeroXTokenAddress(buyERC20Info);
    if (sellTokenAddress === buyTokenAddress) {
        throw new Error('Swap sell and buy tokens are the same.');
    }
    const slippagePercentage = Number(slippageBasisPoints) / 10000;
    const params = {
        sellToken: sellTokenAddress,
        buyToken: buyTokenAddress,
        sellAmount: sellERC20Amount.amount.toString(),
        slippagePercentage: String(slippagePercentage),
    };
    try {
        const { price, buyAmount, guaranteedPrice, allowanceTarget, to, data, value, sellTokenAddress: sellTokenAddressResponse, sellAmount: sellTokenValueResponse, } = await (0, zero_x_fetch_1.getZeroXData)(zero_x_fetch_1.ZeroXApiEndpoint.GetSwapQuote, networkName, isRailgun, params);
        const invalidError = _a.getZeroXQuoteInvalidError(networkName, to, sellTokenAddress, buyTokenAddress);
        if (invalidError) {
            throw invalidError;
        }
        const minimumBuyAmount = (0, number_1.minBalanceAfterSlippage)(BigInt(buyAmount), slippageBasisPoints);
        const crossContractCall = {
            to: to,
            data: data,
            value: BigInt(value),
        };
        const spender = allowanceTarget === NULL_SPENDER_ADDRESS ? undefined : allowanceTarget;
        return {
            price: (0, ethers_1.parseUnits)(price, exports.ZERO_X_PRICE_DECIMALS),
            guaranteedPrice: (0, ethers_1.parseUnits)(guaranteedPrice, exports.ZERO_X_PRICE_DECIMALS),
            buyERC20Amount: {
                ...buyERC20Info,
                amount: BigInt(buyAmount),
            },
            minimumBuyAmount,
            spender,
            crossContractCall,
            slippageBasisPoints,
            sellTokenAddress: sellTokenAddressResponse,
            sellTokenValue: sellTokenValueResponse,
        };
    }
    catch (err) {
        const msg = _a.formatApiError(err);
        throw new Error(msg);
    }
};
ZeroXQuote.formatApiError = (err) => {
    if (!(err instanceof axios_1.AxiosError)) {
        return err.message;
    }
    try {
        const { response } = err;
        if (!response) {
            return `0x API request failed: ${err.message}.`;
        }
        const data = response?.data;
        const firstValidationErrorReason = data?.validationErrors[0].reason;
        if (firstValidationErrorReason === 'INSUFFICIENT_ASSET_LIQUIDITY') {
            return 'Insufficient liquidity. One of the selected tokens is not supported by the 0x Exchange.';
        }
        return `0x Exchange: ${response?.data.reason}. ${firstValidationErrorReason}.`;
    }
    catch {
        return '0x API request failed.';
    }
};
